// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconExport: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13">
            <path
                fill="currentColor"
                d="M4.5,7.3125 C4.5,7.00312471 4.75312507,6.75 5.0625,6.75 L9,6.75 L9,3.75 L6,3.75 C5.58585942,3.75 5.25,3.41414022 5.25,3 L5.25,0 L1.125,0 C0.503672004,0 0,0.503671646 0,1.125 L0,10.875 C0,11.4960938 0.503672004,12 1.125,12 L7.875,12 C8.49632835,12 9,11.4963284 9,10.875 L9,7.875 L5.0625,7.875 C4.75312507,7.875 4.5,7.62421846 4.5,7.3125 Z M6,0 L6,3 L9,3 L6,0 Z M13.3148432,6.9140625 L11.4398432,5.0390625 C11.2201166,4.81933594 10.8642182,4.81933594 10.6443744,5.0390625 C10.4245305,5.25878906 10.4246478,5.61468744 10.6443744,5.83453131 L11.5804689,6.75 L9,6.75 L9,7.875 L11.5804689,7.875 L10.6657033,8.7897656 C10.553906,8.89921904 10.5,9.04218721 10.5,9.1875 C10.5,9.33281279 10.5549374,9.47531247 10.6647892,9.5852344 C10.8845158,9.80496097 11.2404141,9.80496097 11.460258,9.5852344 L13.335258,7.7102344 C13.553906,7.49062514 13.553906,7.13437486 13.3148432,6.9140625 Z"
                transform="translate(0 .5)"
            />
        </svg>
    );
};

export default React.memo(IconExport);
